import { TechnicalModal } from '@/widgets/TechnicalModal';
import type { ErrorInfo, ReactNode } from 'react';
import React, { Component } from 'react';

interface Props {
	children?: ReactNode;
}

interface State {
	hasError: boolean;
	error?: Error;
	errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
	};

	public static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		// this.setState({ error });
		// eslint-disable-next-line no-console
		console.error('Uncaught error:', error, errorInfo);
	}

	public render() {
		const { hasError } = this.state;
		const { children } = this.props;

		if (hasError) {
			return (
				<>
					<div className='w-full h-screen flex justify-center items-center'>
						<TechnicalModal
							title='Something went wrong'
							subtitle='An unknown error occurred. Please try again or contact support.'
							textButton='Try again'
							onClick={() => {
								globalThis.location.reload();
							}}
						/>
					</div>
				</>
			);
		}

		return children;
	}
}

export default ErrorBoundary;
